<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric"; 

export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId","Isteklilerceteklifedilenfiyatlartarih"],
  data() {
    return {
       Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
      Malzemeler: {},
      MalzemeSayisi:0,
      Fiyatlar: [], 
      FiyatSayisi:0,
      FiyatlarArray:[], 
      EnDusukFirmaId:"",
       uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      satdosyaihalekomisyonu:{},
      satdosyafirmafiyat:{},
      satdosyafirma:{},
      satonaybelgesi:{},
      satdosyaihaleilani:{},
      okurumsabit:{},
      yaklasikmaliyet:0,
      Firmalar:{},
      Malzeme:{}, 
      FormData: [],
      Teklifdegerlendirmeyontem:null,
      ToplamkazananFirma:"",
      checkboxdisapled:true,
      durumdisabled:true

    };
  },
  components: {
    Loader
  },
  watch: {
    satdosyaId() { 
    },
  },
  methods: {
     
    Get() {  
      this.ActionsGet({
        Service: "okurumsabit",
        Page: this.Page
      }).then((res) => {
        this.okurumsabit = res.Data[0];
      });

      this.ActionsFilterGet({
        Service: "satdosyaihaleilani",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId,
      }).then((res) => {
        this.satdosyaihaleilani = res.Data[0];
      });

      this.ActionsFilterGet({
        Service: "satonaybelgesi",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId,
      }).then((res) => {
        this.satonaybelgesi = res.Data[0];
      });


      this.ActionsFilterGet({
        Service: "satdosyaihalekomisyonu",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId + "&Asc=Sira",
      }).then((res) => {
        this.satdosyaihalekomisyonu = res.Data;
      });

      this.ActionsGet({"Service":"SatDosya/"+this.satdosyaId, "Page":this.Page}).then((res) => {
    
        this.Dosya = res.Data;
        this.Teklifdegerlendirmeyontem = res.Data.Teklifdegerlendirmeyontem
  
this.ActionsFilterGet({
        Service: "satdosyafirmafiyat/getgiris",
        Page: this.Page,
        Filter:
          "&Dosyaid=" +
          this.satdosyaId +
          "&Asc=Sirano&Fiyatturu=3&TeklifDegerlendirmeYontem="+this.Teklifdegerlendirmeyontem,
      }).then((res) => { 
        this.TableData = res.Data
        this.Firmalar = this.groupBy(res.Data, "Dosyafirmaid");
        this.Malzeme = this.groupBy(res.Data, "Dosyamalzemeid");
        this.FiyatSayisi = Object.keys(this.Firmalar).length
        if(this.Teklifdegerlendirmeyontem == 2){
            this.FormData = []
              for(let Malzeme in this.Malzeme){ 
                 var KazananFirma =null
              if(!this.Malzeme[Malzeme][0].Kazananfirmaid)   {
                KazananFirma = this.Malzeme[Malzeme][0].Hesaplananfirmaid
              }else{
                KazananFirma = this.Malzeme[Malzeme][0].Kazananfirmaid 
              }  
              this.FormData.push({
                "Id": Malzeme, 
                "Dosyaid": this.satdosyaId, 
                "Malzemeid": this.Malzeme[Malzeme][0].Malzemeid,  
                "Kazananfirmaid": KazananFirma, 
                "Durum": this.Malzeme[Malzeme][0].Durum, 
              }) 
        }

      }else{
      
         for(let Firma in this.Firmalar){  
           if(!this.Firmalar[Firma][0].Kazananfirmaid){
          this.ToplamkazananFirma = this.Firmalar[Firma][0].Hesaplananfirmaid
        }else{  
          this.ToplamkazananFirma = this.Firmalar[Firma][0].Kazananfirmaid
        }

           } 
       
      }
  this.EnDusukFirma()
      }); 
             this.ActionsGet({"Service":"OkeyValues/"+this.Dosya.Alimturu, "Page":this.Page}).then((res) => {
                  if(res){
                    if (res.Data.Value=="Mal")
                    {this.Alimturu="M";} 
                    else if (res.Data.Value=="Hizmet"){
                        this.Alimturu="H";
                    }
                     

                  }
             });


      }); 

    },

    FiyatTopla(FirmaId){
      var ToplamFiyat = 0;
      let MalzemeFiyatlari = this.satdosyafirmafiyat.filter((notification) =>
        notification.Dosyafirmaid.includes(FirmaId)
      );  
      for (let i = 0; i < MalzemeFiyatlari.length; i++) {
        ToplamFiyat += MalzemeFiyatlari[i].Birimfiyat * MalzemeFiyatlari[i].Adet;
      }
      return ToplamFiyat
    },
     tlCevir(sayi)
        { 
 
          if(sayi.includes(".") == true){ 
          sayi = sayi.split('.').join(',');
          } 
           var  rakam = sayi.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(",");
           var tamsayi = rakam[0];
           var ondalik = rakam[1]||"";



            var birler = ["","BİR","İKİ","ÜÇ","DÖRT","BEŞ","ALTI","YEDİ","SEKİZ","DOKUZ"];
            var onlar = ["","ON","YİRMİ","OTUZ","KIRK","ELLİ","ALTMIŞ","YETMİŞ","SEKSEN","DOKSAN"];
            var binler = ["","BİN","MİLYON","MİLYAR","TRİLYON","KATRİLYON","KENTİLYON"];
            var sonuc = [];

            var adim = 0;
            for(var i=tamsayi.split(".").length;i>0;i--)
            {
                sayi = tamsayi.split(".")[i-1];
                if(sayi.length==1){ sayi="00"+sayi; }
                if(sayi.length==2){ sayi="0"+sayi; }
                var c="";

                for(var j=1;j<sayi.length+1;j++)
                {
                    if(j==1 && sayi[j-1]==1){ c+= " YÜZ "; }
                    else if(j==1 && birler[sayi[j-1]]!=""){ c+= birler[sayi[j-1]]+" YÜZ "; }
                    else if(j==2){ c+= onlar[sayi[j-1]]+" "; }
                    else if(j==3 && tamsayi.length==5 && sayi[j-1]==1 && adim==1){ c+= " "; }
                    else if(j==3){ c+= birler[sayi[j-1]]+" "; }
                }

                if(c!=""){ sonuc.push(c+binler[adim]); }
                adim++;
            }

            if(sonuc.length!=0){ sonuc = sonuc.reverse().join(" ")+" TL"; }else{ sonuc=""; }
            if(ondalik.length==1){ ondalik=ondalik+"0"; }
             
            if(ondalik!="00"){
                sonuc += " "+onlar[ondalik[0]]+" "+birler[ondalik[1]]+ " KR";
            }

            sonuc = sonuc.replace(/ /g," ").trim();

            return sonuc;
        },
        sayicevir(sayi){
          var  rakam = sayi.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(",");
           var tamsayi = rakam[0];
           var ondalik = rakam[1]||"";



            var birler = ["","BİR","İKİ","ÜÇ","DÖRT","BEŞ","ALTI","YEDİ","SEKİZ","DOKUZ"];
            var onlar = ["","ON","YİRMİ","OTUZ","KIRK","ELLİ","ALTMIŞ","YETMİŞ","SEKSEN","DOKSAN"];
            var binler = ["","BİN","MİLYON","MİLYAR","TRİLYON","KATRİLYON","KENTİLYON"];
            var sonuc = [];

            var adim = 0;
            for(var i=tamsayi.split(".").length;i>0;i--)
            {
                sayi = tamsayi.split(".")[i-1];
                if(sayi.length==1){ sayi="00"+sayi; }
                if(sayi.length==2){ sayi="0"+sayi; }
                var c="";

                for(var j=1;j<sayi.length+1;j++)
                {
                    if(j==1 && sayi[j-1]==1){ c+= " YÜZ "; }
                    else if(j==1 && birler[sayi[j-1]]!=""){ c+= birler[sayi[j-1]]+" YÜZ "; }
                    else if(j==2){ c+= onlar[sayi[j-1]]+" "; }
                    else if(j==3 && tamsayi.length==5 && sayi[j-1]==1 && adim==1){ c+= " "; }
                    else if(j==3){ c+= birler[sayi[j-1]]+" "; }
                }

                if(c!=""){ sonuc.push(c+binler[adim]); }
                adim++;
            }

            if(sonuc.length!=0){ sonuc = sonuc.reverse().join(" ")+" TL"; }else{ sonuc=""; }
            if(ondalik.length==1){ ondalik=ondalik+"0"; }
    
            if(ondalik!=""){
                sonuc += " "+onlar[ondalik[0]]+" "+birler[ondalik[1]]+ " KR";
            }

            sonuc = sonuc.replace(/ /g," ").trim();

            return sonuc;
        },

    ExcelExport(table, name){  
            this.checkboxdisapled = false
            this.durumdisabled = false
            setTimeout( function() { 
                if (!table.nodeType) table = this.$refs.PiyasaArastirmaTutanagi
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
                this.checkboxdisapled = true
                this.durumdisabled = true
            }.bind(this),100); 
      }, 
    Export2Word(element, filename){
   this.checkboxdisapled = false
            this.durumdisabled = false
            setTimeout( function() { 
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = "</body></html>";
    var html = preHtml+document.getElementById(element).innerHTML+postHtml;

    var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
    });
    // Specify link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    
    // Specify file name
    filename = filename?filename+'.doc':'document.doc';
    
    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = url;
        
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
    
    document.body.removeChild(downloadLink);
    
                this.checkboxdisapled = true
            this.durumdisabled = true
            }.bind(this),100); 
    
   },
   KazananFirmaBelirle(){
      if(this.Teklifdegerlendirmeyontem == 2){
          this.UpdateList("satdosyamalzeme/putlistkazananfirma", this.FormData)
      }else{
        var FormData = []
              for(let Malzeme in this.Malzeme){ 
              FormData.push({
                "Id": Malzeme, 
                "Dosyaid": this.satdosyaId, 
                "Malzemeid": this.Malzeme[Malzeme][0].Malzemeid,  
                "Kazananfirmaid": this.ToplamkazananFirma, 
              }) 
              }
              this.UpdateList("satdosyamalzeme/putlistkazananfirma", FormData)

      }
      
    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    
    FirmaToplamFiyat(FirmaId){ 
      var ToplamFiyat = 0;
      var Birimfiyat =0;  
      for (let i = 0; i < this.Firmalar[FirmaId].length; i++) {
        Birimfiyat =  this.Firmalar.[FirmaId][i].Birimfiyat;  
        if(Birimfiyat != null)ToplamFiyat += Birimfiyat
      }
      return ToplamFiyat.toFixed(2);

    },
 

    EnDusukFirma(){   
      var DusukTutar=0;
      for(let Firma in this.Firmalar){ 
         let FirmaToplamSorgu = this.FirmaToplamFiyat(this.Firmalar[Firma][0].Dosyafirmaid)
         if(DusukTutar > FirmaToplamSorgu || DusukTutar == 0){  
           this.EnDusukFirmaToplam = FirmaToplamSorgu
         }
      } 
    }, 
    MalzemeEnDusukFirmaId(MalzemeId,FirmaId){
      if(this.Teklifdegerlendirmeyontem == 2){ 
          var minfiyat = 0
          var firmamalzemefiyat= 0 
          for(let i=0; i<this.Malzeme[MalzemeId].length; i++){  
            if (minfiyat > this.Malzeme[MalzemeId][i].Birimfiyat || minfiyat == 0) {
              if(this.Malzeme[MalzemeId][i].Birimfiyat ) minfiyat = this.Malzeme[MalzemeId][i].Birimfiyat 
            } 
            if(this.Malzeme[MalzemeId][i].Dosyafirmaid == FirmaId){
                firmamalzemefiyat = this.Malzeme[MalzemeId][i].Birimfiyat
              
            } 
          }        
          if(firmamalzemefiyat == minfiyat) {
            return true
          }
          else return false 
      }
       else return false 
    }
         
     
      
  },
   
};
</script>
<template>
  <Loader>
    <b-modal
      id="isteklilerceteklifedilenfiyatlar"
      size="xl"
      scrollable
      :title="$t('isteklilerceteklifedilenfiyatlar.Title')"
      title-class="font-18"
      hide-footer
    >
      <div class="row"> 
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">

                    <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2" 
                      @click="KazananFirmaBelirle()"
                    > 
                      {{ $t("isteklilerceteklifedilenfiyatlar.Page.fiyatlarikaydet") }}
                    </button>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="
                        ExcelExport(
                          'İsteklilerce Teklif Edilen Fiyatlar',
                          'İsteklilerce Teklif Edilen Fiyatlar',
                        )
                      "
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      {{ $t("isteklilerceteklifedilenfiyatlar.Page.ExceleAktar") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="Export2Word('exportContent','İsteklilerce Teklif Edilen Fiyatlar')"
                    > 
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      Word'e Aktar
                    </button>
                  </div>
                </div>
              </div> 
                <div id="exportContent"> 
                  <div class="table-responsive" style="border: 1px solid">  
                    <table
                      class="table table-borderless mb-0"
                      ref="PiyasaArastirmaTutanagi"
                    > 
                      <tbody> 
                        <tr>
                          <td scope="row" style="text-align: left">
                           <b>İhale kayıt numarası:</b> {{ satdosyaihaleilani.Ihalekayitnumarasi}}
                          </td> 
                        </tr>
                        <tr>
                          <td scope="row" style="text-align: left">
                           <b>İdarenin adı:</b> {{ okurumsabit.Kurumadi}} 
                          </td> 
                        </tr>
                        <tr>
                          <td scope="row" style="text-align: left">
                           <b>İşin adı:</b> {{ satonaybelgesi.Isintanimi}}
                          </td> 
                        </tr> 
                        <tr>
                          <td scope="row" style="text-align: left">
                           <b>İşin yaklaşık maliyeti:</b> {{ yaklasikmaliyet | TrParaFormat }} TL
                          </td> 
                        </tr> 
                        <tr>
                          <td scope="row" style="text-align: left">
                           <b>Formun doldurulduğu tarih:</b> {{Isteklilerceteklifedilenfiyatlartarih  | formatDateTime}}
                          </td> 
                        </tr> 
                        <tr></tr>
                         <tr>
                          <th scope="row" style="text-align: center">
                           <b>İSTEKLİLERCE TEKLİF EDİLEN FİYATLAR</b>
                          </th> 
                        </tr> 
                        <tr>
                          <td > 
                            <table style=" border-collapse: collapse; width:100%" class="table table-bordered mb-0">
                              <tbody>
<template v-if="Teklifdegerlendirmeyontem !=2"> 
                                <tr>
                                  <td style="border: 1px solid;" rowspan="2">İsteklinin Adı ve soyadı/ticaret unvanı</td>
                                  <td style="border: 1px solid;" colspan="2">Teklif tutarı</td>
                                </tr>
                                <tr>
                                  <td  style="border: 1px solid;">Rakam ile (TL ) </td>
                                  <td  style="border: 1px solid;">Yazı ile (TÜRK LİRASI )</td>
                                </tr>
                             
   <tr v-for="(Firma, index) in Firmalar"
                                    :key="index">
                                  <td  style="border: 1px solid;">{{Firma[0].Firmaadi}}</td> 
                                  <td  style="border: 1px solid;"
                                  
                                  >
                          <div class="row">
                                    <div class="col-md-4">
                                         <b-form-checkbox 
            v-if="Teklifdegerlendirmeyontem != 2 && checkboxdisapled"
         
        :value="Firma[0].Dosyafirmaid"
        unchecked-value="" 
        class="mb-3" 
        v-model="ToplamkazananFirma" 
        :disabled="Firma[0].Kazananfirmaid"
   
      ></b-form-checkbox>  
      </div>
                                    <div class="col-md-8"> 


                                    {{ FirmaToplamFiyat(Firma[0].Dosyafirmaid) | TrParaFormat }}
                                    </div></div>
                                    </td>
                                  <td  style="border: 1px solid;">{{ tlCevir(FirmaToplamFiyat(Firma[0].Dosyafirmaid)) }}</td>
                                
                                </tr>
</template>

                                   <tr v-if="Teklifdegerlendirmeyontem ==2" >
                          <td colspan="3">
                            <table  class="table table-bordered mb-0" style="border-collapse: collapse; ">
                              <tbody>
                                <tr  >
                                  <th  rowspan="2" style="text-align: center;border: 1px solid;">SIRA NO</th>
                                  <th style="border: 1px solid;"  rowspan="2" v-if="durumdisabled">DURUM</th>
                                  <th style="border: 1px solid;" rowspan="2">MAL / HİZMET / YAPIM İŞİ</th>
                                  <th style="border: 1px solid;" rowspan="2">MİKTAR</th>
                                  <th style="border: 1px solid;" rowspan="2">BİRİM</th>
                                  <th style="border: 1px solid;" :colspan="FiyatSayisi">
                                    KİŞİ / FİRMA / FİRMALAR VE FİYAT TEKLİFLERİ
                                  </th>
                                </tr>
                                <tr    >
                                  <th  style="border: 1px solid;"
                                    v-for="(Firma, index) in Firmalar"
                                    :key="index"
                                  >
                                    {{ Firma[0].Firmaadi}}
                                  </th>
                                </tr>
                                <tr
                                    v-for="(Malzeme,name, index) in Malzeme"
                                  :key="index"
                                >
                                  <td style="text-align: center;border: 1px solid;">{{ Malzeme[0].Sirano }}</td>
                                  <td style="border: 1px solid;" v-if="durumdisabled">
                           
                               <select
        v-model="FormData[index].Durum"
        class="form-select"
        type="text" 
         
      >
        <option value="">{{ $t('OrtakKullanim.seciniz') }}</option>
        <option value=0 >Normal Süreç </option>
        <option value=1 >İptal Edildi </option>
        <option value=2 >Teklif Verilmedi </option>
        <option value=3 >Yaklaşık Maliyet Üstü </option>
      </select>   
                                  
                                  
                                  </td>
                                  <td style="border: 1px solid;">{{ Malzeme[0].Malzemeadi }}</td>
                                  <td style="border: 1px solid;">{{ Malzeme[0].Adet }}</td>
                                  <td style="border: 1px solid;">{{ Malzeme[0].Olcubirimi }}</td>
                                  <template   v-for="(Firma, firmaindex) in Firmalar"
                                 >
                                  <td
                          style="text-align: right;border: 1px solid;"
                                    :key="firmaindex" 
                                 
                                  > 
                 <div class="row">
                                    <div class="col-md-4">
                    
               <b-form-checkbox 
        
                                     v-if="Teklifdegerlendirmeyontem == 2 && checkboxdisapled"
         :value="Firma[0].Dosyafirmaid"
        unchecked-value=""
        :name="index"
        v-model=" FormData[index].Kazananfirmaid"  
        :disabled="Firma[0].Kazananfirmaid"
        class="mb-3" 
   
      ></b-form-checkbox> </div> <div class="col-md-8">
                                      {{
                                    Firma.filter(
                                        (notification) =>
                                          notification.Dosyamalzemeid.includes(
                                          Malzeme[0].Dosyamalzemeid
                                          ) 
                                      )[0].Birimfiyat | TrParaFormat
                                    }}</div></div>
                                  </td>
                                  </template>
                                </tr>
                              
                             
                              
                                <tr > 
                                  <th :colspan="durumdisabled ? 5 : 4" style="text-align: right;border: 1px solid;">
                                    TOPLAM :
                                  </th>
                                  <td 
                                   v-for="(Firma, index) in Firmalar"
                                    :key="index"
                                    :style="[
                                      EnDusukFirmaToplam == FirmaToplamFiyat(Firma[0].Dosyafirmaid) && Teklifdegerlendirmeyontem != 2
                                        ? { background: '#ff9797' }
                                        : { background: '' },
                                    ]"
                                    style="text-align: right;border: 1px solid;"
                                  >
                                     
                         
                                      {{ FirmaToplamFiyat(Firma[0].Dosyafirmaid) | TrParaFormat }}
                                 
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                                
                                <tr> 
                                <td colspan="3">
                                  İhaleye {{ FiyatSayisi }} ({{ sayicevir(FiyatSayisi) }}) istekli katılmış olup verdikleri fiyatlar ve yaklaşık maliyet yukarıda belirtilmiş ve hazır bulunanlara açıklanmıştır.
                                </td>
                                </tr> 
                                 
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                        </tr>
                        <tr>
                          <td></td>
                        </tr>
                        <tr>
                          <th  scope="row" style="text-align: center">İHALE KOMİSYONU</th>
                        </tr>
                        <tr>
                          <td colspan="2">
                            <table
                              class="table table-borderless mb-0"
                              style=" width:100%; border-collapse: collapse;"
                            >
                              <tbody>
                                <tr>
                                  <td  style="border: 1px solid;"
                                    v-for="(
                                      ihalekomisyonu, index
                                    ) in satdosyaihalekomisyonu"
                                    :key="index"
                                  > <center>
                                    {{ ihalekomisyonu.Yedekkatildi == false ? ihalekomisyonu.Asilpersonel : ihalekomisyonu.Yedekpersonel  }}
                                 </center> </td>
                                </tr>
                                <tr>
                                  <td  style="border: 1px solid;"
                                    v-for="(
                                      ihalekomisyonu, index
                                    ) in satdosyaihalekomisyonu"
                                    :key="index"
                                  ><center>
                                    {{ ihalekomisyonu.Yedekkatildi == false ? ihalekomisyonu.Asilunvan : ihalekomisyonu.Yedekunvan  }}
                                 </center> </td>
                                </tr>
                                <tr>
                                  <td  style="border: 1px solid;"
                                    v-for="(
                                      ihalekomisyonu, index
                                    ) in satdosyaihalekomisyonu"
                                    :key="index"
                                  ><center>
                                    {{ ihalekomisyonu.Gorevi }}
                                  </center></td>
                                </tr>
                                <tr>
                                  <td  style="border: 1px solid;"
                                    v-for="(
                                      ihalekomisyonu, index
                                    ) in satdosyaihalekomisyonu"
                                    :key="index"
                                  ><center>
                                    İmzası
                                  </center></td>
                                </tr>
                              </tbody>
                           
                            </table>
                          </td>
                        </tr>
                         <tr>
                          <td style="text-align: right">
                            Standart Form ─ KİK016.0/{{Alimturu}}
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: right">
                            Açık İhale, Belli İstekliler Arasında İhale ve Pazarlık Usullerinde Teklif Edilen Fiyatlar ve Yaklaşık Maliyetin Açıklanmasına İlişkin Tutanak
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>
